module.exports = __webpack_public_path__ + "img/product-fill.5a88f443.svg";